import type { ComponentDefinition } from '@wix/platform-editor-sdk';

import {
  shouldUseLoginSocialBarV2,
  shouldUseScalableDimensionsForLoginBarOnBuilderEditor,
} from '../../../../utils/experiments';
import { resolveBuilderLoginBarComponentRef } from './builder-editor-login-bar-component-ref';
import {
  COMMON_LOGIN_COMP_CONNECTIONS_V2,
  LOGIN_SOCIAL_BAR_V1_DEFAULT_WIDTH,
} from './common-login-bar-layouts';
import { LOGIN_COMP_RESPONSIVE_APP_WIDGET } from './responsive-login-bar-layouts';

const getLoginBarBuilderEditorCompDef = async () => {
  const [useScalableDimensions, useLoginSocialBarV2] = await Promise.all([
    shouldUseScalableDimensionsForLoginBarOnBuilderEditor(),
    shouldUseLoginSocialBarV2(),
  ]);

  const responsiveWidth = useLoginSocialBarV2
    ? { type: 'maxContent' }
    : { type: useScalableDimensions ? 'spx' : 'px', value: LOGIN_SOCIAL_BAR_V1_DEFAULT_WIDTH };

  const responsiveHeight = useLoginSocialBarV2
    ? { height: { type: 'auto' } }
    : useScalableDimensions
      ? { height: { type: 'spx', value: 40 } }
      : { height: { type: 'px', value: 40 }, minHeight: { type: 'px', value: 40 } };

  return {
    componentType: resolveBuilderLoginBarComponentRef(useLoginSocialBarV2),
    layout: {
      width: LOGIN_SOCIAL_BAR_V1_DEFAULT_WIDTH,
      height: 40,
      x: 740,
      y: 24,
    },
    connections: COMMON_LOGIN_COMP_CONNECTIONS_V2,
    layoutResponsive: {
      type: 'LayoutData',
      componentLayouts: [
        {
          type: 'ComponentLayout',
          width: responsiveWidth,
          ...responsiveHeight,
        },
      ],
      itemLayouts: LOGIN_COMP_RESPONSIVE_APP_WIDGET.layoutResponsive.itemLayouts,
      containerLayouts: [],
    },
  } as unknown as ComponentDefinition;
};

export { getLoginBarBuilderEditorCompDef };
